// Maps a thrown sendSMS GraphQL error to a user-facing snackbar message based
// on the server's `extensions.code`. The server's sendSMS now THROWS on
// failure (the old "returns null" behavior is gone) with one of these codes:
//   VALIDATION_FAILED      — Twilio 21211, the destination number is invalid
//   CONFLICT               — Twilio 21610, recipient texted STOP / unsubscribed
//   INTERNAL_SERVER_ERROR  — generic send failure (wire value is
//                            INTERNAL_SERVER_ERROR, NOT INTERNAL)
//
// Returns a stable message string. The typed text is preserved by the caller
// regardless of which branch fires.
export default function smsErrorMessage(error) {
  const code = error?.graphQLErrors?.[0]?.extensions?.code;

  switch (code) {
    case "VALIDATION_FAILED":
      return "That phone number is invalid — message not sent.";
    case "CONFLICT":
      return "This recipient has unsubscribed (texted STOP). Twilio rejected the message.";
    case "DUPLICATE_THREAD":
      return "This number already has a text thread under another contact — open it from the Messages page.";
    case "INTERNAL_SERVER_ERROR":
      return "Message failed to send. Please try again.";
    default:
      // Network failure / unknown — still surface something actionable.
      return "Message failed to send. Please try again.";
  }
}
